import { render } from "./QueryPage.vue?vue&type=template&id=73e06920&scoped=true"
import script from "./QueryPage.vue?vue&type=script&lang=js"
export * from "./QueryPage.vue?vue&type=script&lang=js"

import "./QueryPage.vue?vue&type=style&index=0&id=73e06920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e06920"]])

export default __exports__